module.exports = __webpack_public_path__ + "static/media/bannerDesktop@1x.6919ec7d.jpg";